import { render, staticRenderFns } from "./Hand.vue?vue&type=template&id=bc71befa&scoped=true&"
import script from "./Hand.vue?vue&type=script&lang=js&"
export * from "./Hand.vue?vue&type=script&lang=js&"
import style0 from "./Hand.vue?vue&type=style&index=0&id=bc71befa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc71befa",
  null
  
)

export default component.exports